var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      { staticClass: "txt-img-card__container", attrs: { href: _vm.url } },
      [
        _c("div", { staticClass: "txt-img-card__img-bg" }),
        _vm._v(" "),
        _c("div", { staticClass: "txt-img-card__txt-bg" }, [
          _c("div", { staticClass: "txt-img-card__headline" }, [
            _vm._v(_vm._s(_vm.headline))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "txt-img-card__content-subheadline" }, [
            _vm._v(_vm._s(_vm.contentsubheadline))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "txt-img-card__txt",
            domProps: { innerHTML: _vm._s(_vm.text) }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "txt-img-card__img" }, [
          _c("img", { attrs: { src: _vm.image, alt: "Background Image" } })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }